var _excluded = ["text"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import React, { useState } from 'react';
import classnames from 'classnames';
import { Button } from "../../Button/Button/Button";
import Colors from "../../Color/Colors";
import { Container } from "../../Container/Container/Container";
import { CheckboxInput } from "../../Input/CheckboxInput/CheckboxInput";
import { HeadingText } from "../../Text/HeadingText/HeadingText";
import { Image } from "../../Image/Image/Image";
import { SpinnerIndicator } from "../../Indicator/SpinnerIndicator/SpinnerIndicator";
import { Text } from "../../Text/Text/Text";
import { Theme } from "../../Background/Theme/Theme";
import { TwoColumn } from "../../TwoColumn/TwoColumn";
import { ValidatedInput } from "../../Input/ValidatedInput/ValidatedInput";
import styles from "./EmailCaptureSlice.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var emailCaptureSliceAlign = ['left', 'center'];
export var emailCaptureTypogOption = ['headline3', 'headline4'];
export var emailCaptureSliceButtonTypes = ['link', 'primary', 'secondary'];
export var emailCaptureSliceBgColors = ['#181877',
// WW100
'#3C34E5',
// WW110
'#ACD9F3',
// WW120
'#EBEBFC',
// WW220-10
'#B9B1FA',
// WW310
'#CCD7D2',
// WW320
'#FBF3EB',
// WW420-10
'#FFFFFF',
// WW500
'#F4F5F9' // WW510
];
var LayoutContainer = function LayoutContainer(_ref) {
  var twoColumn = _ref.twoColumn,
    theme = _ref.theme,
    children = _ref.children;
  var twoColumnProps = Object.assign({}, {
    background: {},
    children: null,
    offset: 'left',
    columnOneConfig: {
      verticalAlign: 'center'
    },
    columnTwoConfig: {
      verticalAlign: 'center'
    },
    breakpoint: 'small',
    verticalSpacer: {
      padding: 'default'
    }
  }, twoColumn);
  return twoColumn ? /*#__PURE__*/_jsx(TwoColumn, _objectSpread(_objectSpread({}, twoColumnProps), {}, {
    children: React.Children.map(children, function (child) {
      return /*#__PURE__*/_jsx(Theme, {
        theme: theme,
        children: /*#__PURE__*/_jsx("div", {
          className: styles.columnContent,
          children: child
        })
      });
    })
  })) : /*#__PURE__*/_jsx("div", {
    className: styles.content,
    children: children
  });
};
export var EmailCaptureSlice = function EmailCaptureSlice(_ref2) {
  var _ref2$align = _ref2.align,
    align = _ref2$align === void 0 ? 'left' : _ref2$align,
    twoColumn = _ref2.twoColumn,
    _ref2$icon = _ref2.icon,
    icon = _ref2$icon === void 0 ? {} : _ref2$icon,
    _ref2$headline = _ref2.headline,
    headline = _ref2$headline === void 0 ? {
      ariaLevel: 2,
      text: '',
      typog: 'headline4'
    } : _ref2$headline,
    _ref2$bodyText = _ref2.bodyText,
    bodyText = _ref2$bodyText === void 0 ? '' : _ref2$bodyText,
    _ref2$cta = _ref2.cta,
    cta = _ref2$cta === void 0 ? {
      accessibilityLabel: '',
      text: '',
      type: 'primary',
      onClick: function onClick() {}
    } : _ref2$cta,
    _ref2$ctaTwo = _ref2.ctaTwo,
    ctaTwo = _ref2$ctaTwo === void 0 ? {
      accessibilityLabel: '',
      url: '',
      text: '',
      type: 'primary',
      newWindow: false
    } : _ref2$ctaTwo,
    _ref2$ctaWithEmailInp = _ref2.ctaWithEmailInput,
    ctaWithEmailInput = _ref2$ctaWithEmailInp === void 0 ? false : _ref2$ctaWithEmailInp,
    emailInput = _ref2.emailInput,
    firstNameInput = _ref2.firstNameInput,
    lastNameInput = _ref2.lastNameInput,
    zipInput = _ref2.zipInput,
    telephoneInput = _ref2.telephoneInput,
    _ref2$optinCheckbox = _ref2.optinCheckbox,
    optinCheckbox = _ref2$optinCheckbox === void 0 ? {} : _ref2$optinCheckbox,
    _ref2$ageCheckbox = _ref2.ageCheckbox,
    ageCheckbox = _ref2$ageCheckbox === void 0 ? {} : _ref2$ageCheckbox,
    _ref2$thirdCheckbox = _ref2.thirdCheckbox,
    thirdCheckbox = _ref2$thirdCheckbox === void 0 ? {} : _ref2$thirdCheckbox,
    _ref2$form = _ref2.form,
    form = _ref2$form === void 0 ? {
      errorMessage: '',
      loading: false,
      success: false,
      successMessage: ''
    } : _ref2$form,
    _ref2$disclaimer = _ref2.disclaimer,
    disclaimer = _ref2$disclaimer === void 0 ? '' : _ref2$disclaimer,
    _ref2$theme = _ref2.theme,
    theme = _ref2$theme === void 0 ? 'lightBackground' : _ref2$theme,
    backgroundColor = _ref2.backgroundColor;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    optin = _useState2[0],
    setOptin = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    age = _useState4[0],
    setAge = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    chk3 = _useState6[0],
    setChk3 = _useState6[1];
  var toggleCheckmark = function toggleCheckmark(id, onChange) {
    if (onChange) {
      onChange();
    }
    switch (id) {
      case 'optin':
        setOptin(!optin);
        break;
      case 'age':
        setAge(!age);
        break;
      case 'chk3':
        setChk3(!chk3);
        break;
    }
  };
  var renderCTA = function renderCTA(cta) {
    var loading = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var text = cta.text,
      otherProps = _objectWithoutProperties(cta, _excluded);
    var styles = {
      display: 'inline-block',
      height: '25px',
      marginBottom: '2px',
      marginLeft: (text === null || text === void 0 ? void 0 : text.length) && '8px',
      position: 'absolute',
      verticalAlign: 'middle'
    };
    var buttonChild = loading ? /*#__PURE__*/_jsxs("div", {
      style: {
        paddingRight: '25px'
      },
      children: [text, /*#__PURE__*/_jsx("div", {
        style: styles,
        children: /*#__PURE__*/_jsx(SpinnerIndicator, {
          size: "25px"
        })
      })]
    }) : text;
    return /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
      size: "large",
      disabled: loading
    }, otherProps), {}, {
      children: buttonChild
    }));
  };
  var _ref3 = form || {},
    errorMessage = _ref3.errorMessage,
    loading = _ref3.loading,
    success = _ref3.success,
    successMessage = _ref3.successMessage;
  var hasCTA = cta === null || cta === void 0 ? void 0 : cta.text;
  var hasCTATwo = ctaTwo === null || ctaTwo === void 0 ? void 0 : ctaTwo.text;
  var hasCTAs = hasCTA && !ctaWithEmailInput || hasCTATwo;
  var hasCheckboxes = (optinCheckbox === null || optinCheckbox === void 0 ? void 0 : optinCheckbox.label) || (ageCheckbox === null || ageCheckbox === void 0 ? void 0 : ageCheckbox.label) || (thirdCheckbox === null || thirdCheckbox === void 0 ? void 0 : thirdCheckbox.label);
  var nothingBelowCTA = !errorMessage && !hasCheckboxes && !disclaimer;
  var backgroundStyle = {
    backgroundColor: backgroundColor
  };

  // Dark WW100 design
  var variant = theme === 'darkBackground' && backgroundColor === Colors.colorWW100 ? 'wwBlue' : 'default';
  var statusMessageClassName = variant === 'wwBlue' ? styles.statusMessageDarkBackground : undefined;
  var fullEmailInput = Object.assign({}, emailInput, ctaWithEmailInput ? {
    buttonText: cta.text
  } : null);
  return /*#__PURE__*/_jsx(Theme, {
    theme: theme,
    children: /*#__PURE__*/_jsx("div", {
      className: styles.wrapper,
      style: backgroundStyle,
      children: /*#__PURE__*/_jsx(Container, {
        children: /*#__PURE__*/_jsxs(LayoutContainer, {
          twoColumn: twoColumn,
          theme: theme,
          children: [/*#__PURE__*/_jsxs("div", {
            className: styles.contentHeadings,
            children: [(icon === null || icon === void 0 ? void 0 : icon.image1x) && /*#__PURE__*/_jsx("div", {
              className: classnames({
                [styles.icon]: true,
                [styles.centered]: align === 'center'
              }),
              children: /*#__PURE__*/_jsx(Image, {
                src: icon.image1x,
                alt: icon.alt,
                style: {
                  width: icon.width,
                  height: icon.height
                },
                transformations: {
                  image1x: {
                    width: parseInt((icon === null || icon === void 0 ? void 0 : icon.width) || '', 10) || undefined
                  },
                  image2x: {
                    width: parseInt((icon === null || icon === void 0 ? void 0 : icon.width) || '', 10) * 2 || undefined
                  }
                },
                forceTwoXInSrc: true,
                loading: icon.loading || 'eager'
              })
            }), (headline === null || headline === void 0 ? void 0 : headline.text) && /*#__PURE__*/_jsx(HeadingText, {
              className: styles.headline,
              align: align,
              ariaLevel: 2,
              typog: headline.typog,
              children: headline.text
            }), bodyText && /*#__PURE__*/_jsx(Text, {
              align: align,
              className: styles.body,
              typog: "bodycopyLarge",
              richText: true,
              children: bodyText
            })]
          }), /*#__PURE__*/_jsxs("div", {
            children: [success && successMessage && /*#__PURE__*/_jsx(Text, {
              align: align,
              className: styles.body,
              typog: "bodycopyLarge",
              richText: true,
              children: successMessage
            }), !success && /*#__PURE__*/_jsxs("div", {
              children: [/*#__PURE__*/_jsxs("div", {
                className: styles.inputsWrapper,
                children: [firstNameInput && /*#__PURE__*/_jsx(ValidatedInput, _objectSpread({
                  className: styles.formInput,
                  statusMessageClassName: statusMessageClassName,
                  hasButton: false,
                  variant: variant
                }, firstNameInput)), lastNameInput && /*#__PURE__*/_jsx(ValidatedInput, _objectSpread({
                  className: styles.formInput,
                  statusMessageClassName: statusMessageClassName,
                  hasButton: false,
                  variant: variant
                }, lastNameInput)), emailInput && /*#__PURE__*/_jsx(ValidatedInput, _objectSpread({
                  className: styles.formInput,
                  statusMessageClassName: statusMessageClassName,
                  hasButton: hasCTA && ctaWithEmailInput ? true : false,
                  variant: variant,
                  loading: ctaWithEmailInput && loading
                }, fullEmailInput)), zipInput && /*#__PURE__*/_jsx(ValidatedInput, _objectSpread({
                  className: styles.formInput,
                  statusMessageClassName: statusMessageClassName,
                  hasButton: false,
                  variant: variant
                }, zipInput)), telephoneInput && /*#__PURE__*/_jsx(ValidatedInput, _objectSpread({
                  className: styles.formInput,
                  statusMessageClassName: statusMessageClassName,
                  hasButton: false,
                  variant: variant
                }, telephoneInput))]
              }), hasCheckboxes && /*#__PURE__*/_jsxs("div", {
                className: styles.checkboxesWrapper,
                children: [(optinCheckbox === null || optinCheckbox === void 0 ? void 0 : optinCheckbox.label) && /*#__PURE__*/_jsx(CheckboxInput, {
                  name: "optin",
                  className: styles.formCheckbox,
                  label: optinCheckbox.label,
                  errorMessage: optinCheckbox.errorMessage,
                  statusMessageClassName: statusMessageClassName,
                  checked: optin,
                  onChange: function onChange() {
                    return toggleCheckmark('optin', optinCheckbox.onChange);
                  }
                }), (ageCheckbox === null || ageCheckbox === void 0 ? void 0 : ageCheckbox.label) && /*#__PURE__*/_jsx(CheckboxInput, {
                  name: "age",
                  className: styles.formCheckbox,
                  label: ageCheckbox.label,
                  errorMessage: ageCheckbox.errorMessage,
                  statusMessageClassName: statusMessageClassName,
                  checked: age,
                  onChange: function onChange() {
                    return toggleCheckmark('age', ageCheckbox.onChange);
                  }
                }), (thirdCheckbox === null || thirdCheckbox === void 0 ? void 0 : thirdCheckbox.label) && /*#__PURE__*/_jsx(CheckboxInput, {
                  name: "chk3",
                  className: styles.formCheckbox,
                  label: thirdCheckbox.label,
                  errorMessage: thirdCheckbox.errorMessage,
                  statusMessageClassName: statusMessageClassName,
                  checked: chk3,
                  onChange: function onChange() {
                    return toggleCheckmark('chk3', thirdCheckbox.onChange);
                  }
                })]
              }), hasCTAs && /*#__PURE__*/_jsxs("div", {
                className: classnames({
                  [styles.ctasWrapper]: true,
                  [styles.centered]: align === 'center'
                }),
                children: [hasCTA && !ctaWithEmailInput && /*#__PURE__*/_jsx("div", {
                  className: classnames({
                    [styles.cta]: true,
                    [styles.lastItem]: nothingBelowCTA
                  }),
                  children: renderCTA(cta, loading)
                }), hasCTATwo && /*#__PURE__*/_jsx("div", {
                  className: classnames({
                    [styles.cta]: true,
                    [styles.lastItem]: nothingBelowCTA
                  }),
                  children: renderCTA(ctaTwo)
                })]
              }), errorMessage && /*#__PURE__*/_jsx(Text, {
                align: align,
                className: styles.error,
                typog: "bodycopy",
                children: errorMessage
              }), disclaimer && /*#__PURE__*/_jsx(Text, {
                align: align,
                typog: "captionSmall",
                richText: true,
                children: disclaimer
              })]
            })]
          })]
        })
      })
    })
  });
};